import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Form from './formId';

export default () => {
  return (
    <Switch>
      <Route path="/forms/:formId" component={Form} />
    </Switch>
  );
};
